import React, { FC, useMemo, useEffect, useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { push as libPush } from '@centra/centra-ui'
import { Redirect, Route, Switch, useHistory } from 'react-router'
import GlobalLayout from './GlobalLayout'
import NotFound from 'components/NotFound'

import { FastWidget } from '../../components/FastWidget/FastWidget'

import { ScrollToTop } from 'components/Common'
import routesTemplates from 'settings/routes'
import { getAllowedRoutes } from 'utils'
import LayoutPageProperties from 'settings/routes/types/LayoutPageProperties'
import { RouteTemplateProperties } from 'settings/routes/types/RouteTemplateProperties'
import { AppContext, COMMON_LINKS, getCookie, UnitGlobal, useHasUserTag } from '@centra/centra-ui'
import { COOKIE_NAME, API_URL } from '../../services/api'
import jwtDecode from 'jwt-decode'
import { ActionType, IUser } from 'store/authentication/model'
import { useClient } from 'hooks/useClient'
import { NOTIFICATION_MESSAGES } from './const'
import { useRedirectToTaskTracker } from 'hooks/useRedirectToTasktracker'
import { useRedirectToCMS } from 'hooks/useRedirectToCMS'

export const Layout = () => {
  const { user } = useSelector(({ auth }) => auth)
  const isAdminContent = useHasUserTag(['role.admin-content'])
  const isClient = useHasUserTag('customerUser')

  const { setNotification } = useContext(AppContext)
  useClient()
  const { location, push } = useHistory()
  const dispatch = useDispatch()
  const allowedRoutes: RouteTemplateProperties[] = useMemo(() => getAllowedRoutes(routesTemplates, user?.tags), [user])

  useEffect(() => {
    if (location.search) {
      const url = new URL(window.location.href)

      Object.entries(NOTIFICATION_MESSAGES).forEach(([key, values]) => {
        if (url.searchParams.get(key) === values.value) {
          setNotification(values.notification)
          url.searchParams.delete(key)
          push(url.pathname)
        }
      })
    }
  }, [])

  useEffect(() => {
    const jwt = getCookie(COOKIE_NAME)
    try {
      //TODO: больше так не получаем юзера - берем из стора эффектора
      const user = jwtDecode(jwt as string) as IUser
      if (user) {
        dispatch({
          type: ActionType.SET_USER,
          payload: {
            jwt,
            ...user,
          },
        })
      }
    } catch {
      console.error('error decode token!')
    }
  }, [])

  const isRender = useRedirectToTaskTracker()
  const isRenderForAdminContent = useRedirectToCMS()

  if (!isRender || !isRenderForAdminContent) return null

  return (
    <UnitGlobal
      statUrl={API_URL + 'unit-audit/log'}
      bundleId={'platform'}
      userId={user && user?.id > 0 ? `${user.id}` : undefined}
    >
      <ScrollToTop>
        <Switch>
          {allowedRoutes.map(routesTemplate => {
            const { routes, template: Template } = routesTemplate
            return routes.map(routes => {
              const TemplateLayout: FC<LayoutPageProperties> = routes.template ? routes.template : Template
              return (
                <Route
                  exact={routes.exact}
                  path={routes.path}
                  key={routes.path}
                  render={route => {
                    if (!route.location.pathname) {
                      return <Redirect to="/" />
                    }

                    if (isAdminContent && route.location.pathname === '/') {
                      libPush(`${window.location.origin}/${COMMON_LINKS.CMS}`)
                      return null
                    }
                    return <TemplateLayout Component={routes.component} route={route} {...routes.params} />
                  }}
                />
              )
            })
          })}
          <Route path="/login" render={() => <Redirect to="/" />} />
          <Route path={COMMON_LINKS.TASK.href} exact render={() => <Redirect to="/" />} />
          <Route
            path={COMMON_LINKS.CUSTOMER.href}
            render={route => {
              window.location.href = route.location.pathname
              return null
            }}
          />
          <Route render={route => <GlobalLayout Component={NotFound} route={route} />} />
        </Switch>
      </ScrollToTop>
      {isClient && <FastWidget path={location.pathname} push={push} pushOld={push} query={location.search} />}
    </UnitGlobal>
  )
}
